/**
 * values for setting the 'validationType' in address fields
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const VALIDATION_TYPE = {
  COMPOUND: 'compound',
  DISTINCT: 'distinct',
};

const VALIDATION_TYPE_ALL = _.values(VALIDATION_TYPE, 'value');

const VALIDATION_TYPE_LIST = [
  {
    text:        locale('Validate as a single, compound field'),
    value:       VALIDATION_TYPE.COMPOUND,
    description: 'Validation occurs after all fields have been navigated (single error message).',
  },
  {
    text:        locale('Validate as individual fields'),
    value:       VALIDATION_TYPE.DISTINCT,
    description: 'Validation occurs inline as the user navigates each field (field-level error messages).',
  },
];

export { VALIDATION_TYPE, VALIDATION_TYPE_LIST, VALIDATION_TYPE_ALL };

export default VALIDATION_TYPE;
